import { ColumnSetting } from "lib/types/models";

export type BuyerColumns = "name" | "notice" | "country" | "town" | "region" | "signals";

export const ALL_BUYER_COLUMNS: ColumnSetting<BuyerColumns>[] = [
  { title: "Buyer name", field: "name", disabled: true },
  { title: "Notices", field: "notice" },
  { title: "Country", field: "country" },
  { title: "Town", field: "town" },
  { title: "Region", field: "region" },
  { title: "Signals", field: "signals" },
];

const columnCopies: Record<BuyerColumns, string> = ALL_BUYER_COLUMNS.reduce(
  (acc, { title, field }) => {
    if (field === "name") {
      return { ...acc, buyer_name: title };
    }
    if (field === "notice") {
      return { ...acc, total_record_count: title };
    }
    return { ...acc, [field]: title };
  },
  {} as Record<BuyerColumns, string>,
);

export const getBuyersColumnCopy = (column?: string): string => {
  if (!column || !(column in columnCopies)) return "";
  return columnCopies[column as BuyerColumns];
};
